import React from 'react';
import { Select as SelectComponent } from 'antd';
import { SelectProps, SelectValue } from 'antd/lib/select';

export const Select: React.FC<SelectProps<SelectValue>> = React.memo(props => (
  <SelectComponent data-testid='select-input' {...props} style={{ width: '100%' }} />
));

export const { Option } = SelectComponent;
